module.exports = {
    login: [
        {
            name: 'login',
            id: 'login'
        }
    ],
    registration: [
        {
            name: 'registration',
            id: 'registration'
        }
    ],
    registrationExtra: [
        {
            name: 'registration-extra',
            id: 'registration-extra'
        }
    ],
    restore: [
        {
            name: 'restore',
            id: 'restore'
        }
    ],
    restoreChange: [
        {
            name: 'restore-change',
            id: 'restore-change'
        }
    ],
    alert: [
        {
            name: 'alert',
            id: 'alert'
        }
    ]
};



// WEBPACK FOOTER //
// ./actions/compositions/auth.js